'use client';
import { type WheelEvent } from 'react';
import { twMerge } from 'tailwind-merge';

type TInput = {
  id: string;
  label: string;
  value?: string;
  onChange?: (e: string) => void;
  type?: 'text' | 'number' | 'email';
  required?: boolean;
  className?: string;
  blacked?: boolean;
  defaultValue?: string;
  errorMessage?: string;
  placeholder?: string;
};

export const Input = ({
  id,
  label,
  value,
  onChange,
  className,
  type = 'text',
  required = false,
  blacked = false,
  defaultValue,
  placeholder = '',
  errorMessage
}: TInput) => {
  return (
    <div className="flex flex-col text-foreground gap-1.5">
      <label
        htmlFor={id}
        className={twMerge('tracking-wider font-semibold text-sm pl-1', blacked && 'text-background')}
      >
        {label}
        {required && <span className="ml-0.5 text-red-600">*</span>}
      </label>
      <input
        type={type}
        id={id}
        name={id}
        aria-label={label}
        onWheel={(e: WheelEvent<HTMLInputElement>) => {
          e.currentTarget.blur();
        }}
        onChange={e => onChange?.(e.target.value)}
        value={value}
        defaultValue={defaultValue}
        placeholder={placeholder}
        className={twMerge(
          'rounded-xl border px-4 py-2.5 text-sm font-semibold tracking-wide transition-colors duration-200 text-foreground placeholder:text-foreground/50 shadow-[inset_0_1px_1px_rgba(255,255,255,0.08)] selection:bg-action/20 selection:text-background focus-visible:outline-none focus-visible:ring-[1.5px]',
          !blacked &&
            'border-foreground/25 bg-backgroundLight/60 hover:border-action/70 hover:bg-backgroundLight/70 focus-visible:border-action/80 focus-visible:ring-action/70',
          type === 'number' &&
            'appearance-none [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none [&::-moz-appearance]:textfield',
          blacked &&
            'border-background/90 bg-transparent text-background placeholder:text-background/60 hover:bg-transparent hover:border-background focus-visible:border-background focus-visible:ring-background/60 selection:bg-background selection:text-foreground',
          className
        )}
      />
      {errorMessage && <span className="text-xs text-red-600">{errorMessage}</span>}
    </div>
  );
};
